import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiEndPoint, StatusCode } from "../../services/helper";
import API from "../../services/api";
import { toast } from "react-toastify";
const initialState = {
  ProductManagementData: [],
  status: StatusCode.IDLE,
  brandList: [],
};
const { DELETEKITMANAGEMENTDATA, FETCH_BRANDS, PRODUCTMANAGEMENT } =
  ApiEndPoint;
export const ProductManagementSlice = createSlice({
  name: "Productmanagement",
  initialState,
  reducers: {
    setProductManagementData: (state, action) => {
      state.ProductManagementData = action.payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductsManagementData.pending, (state) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(fetchProductsManagementData.fulfilled, (state, action) => {
        state.ProductManagementData = action.payload.data.products;
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchProductsManagementData.rejected, (state) => {
        state.status = StatusCode.ERROR;
      })
      // DELETE PRODUCT
      .addCase(deleteProductManagementData.fulfilled, (state) => {
        state.status = StatusCode.IDLE;
      })

      .addCase(deleteProductManagementData.rejected, (state) => {
        state.status = StatusCode.ERROR;
      })
      .addCase(fetchBrands.pending, (state) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.brandList = action?.payload?.data ?? [];
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchBrands.rejected, (state) => {
        state.status = StatusCode.ERROR;
      });
  },
});

export const { setProductManagementData } = ProductManagementSlice.actions;
export default ProductManagementSlice.reducer;

export const fetchProductsManagementData = createAsyncThunk(
  "admin/get/products",
  async () => {
    try {
      const res = await API.get(PRODUCTMANAGEMENT);
      if (res.data?.status === 200) {
        return res.data;
      }
    } catch (error) {
      console.error("Failed to fetch product management data:", error);
      throw error;
    }
  }
);

export const deleteProductManagementData = createAsyncThunk(
  "admin/delete/product",
  async (data) => {
    try {
      const res = await API.delete(`${DELETEKITMANAGEMENTDATA}`, {
        data: data,
      });
      if (res.status === 200) {
        toast.success(res?.data?.message);
        return res?.data;
      }
    } catch (error) {
      toast.error(error.data?.message);
      throw error;
    }
  }
);

export const fetchBrands = createAsyncThunk("admin/get/brands", async () => {
  try {
    const res = await API.get(FETCH_BRANDS);
    if (res.data?.status === 200) {
      return res.data;
    }
  } catch (error) {
    console.error("Failed to fetch product management data:", error);
    throw error;
  }
});
